export default __webpack_public_path__ + "static/media/back.6e61b058.svg";